"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.allowedSocialPlatforms = exports.DETAIL_ITEM_SHARE = void 0;
const DETAIL_ITEM_SHARE = exports.DETAIL_ITEM_SHARE = 'detail-item-share';
const allowedSocialPlatforms = exports.allowedSocialPlatforms = ['facebook', 'vkontakte', 'email', 'twitter'];
